import { Text, TokenTextAppearance, TextTag, styled } from '@volkswagen-onehub/components-core';
import React from 'react';
import Vehicles from '../../components/Vehicles';
import useGetVehicles from '../../hooks/use-get-vehicles';
import useTrans from '../../hooks/use-trans';

const SelectionsContainer = styled.div``;

export default () => {

    useGetVehicles();

    const trans = useTrans();

    return (
        <SelectionsContainer>
            <Text
                appearance={TokenTextAppearance.super100}>{trans.title[0]} <Text tag={TextTag.span} bold>{trans.title[1]}</Text></Text>

            <Vehicles />
        </SelectionsContainer>
    );
}
